module.exports = __webpack_public_path__ + "static/media/link_blue.3ed7bb46.svg";